// extracted by mini-css-extract-plugin
export default {"speechBalloon":"HintFuckingMonkeys_speechBalloon__2+qu-","text":"HintFuckingMonkeys_text__rNVS4"};